import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["groups", "locations", "reportName", "dateRange", "dateRangeParent", "dateRangeNotice", "dateRangeError"];

  validate(e) {
    const groups = this.groupsTarget.children[1].value || "";
    const locations = this.locationsTarget.children[1].value || "";
    const reportName = this.reportNameTarget.children[1].value || "";
    const dateRange = this.dateRangeTarget.value || "";
    const groupsError = this.groupsTarget.children[4];
    const locationsError = this.locationsTarget.children[4];
    const reportNameError = this.reportNameTarget.children[4];
    const validDateRanges = this.checkDateRanges(dateRange);

    if (locations.length + groups.length == 0) {
      this.groupsTarget.classList.add("error");
      groupsError.textContent = "Please select a group or location.";
      this.locationsTarget.classList.add("error");
      locationsError.textContent = "Please select a group or location.";
    } else {
      this.groupsTarget.classList.remove("error");
      groupsError.textContent = "";
      this.locationsTarget.classList.remove("error");
      locationsError.textContent = "";
    }

    if (reportName.length == 0) {
      this.reportNameTarget.classList.add("error");
      reportNameError.textContent = "Field is required";
    } else {
      this.reportNameTarget.classList.remove("error");
      reportNameError.textContent = "";
    }

    if (dateRange.length == 0) {
      this.dateRangeNoticeTarget.classList.add("d-none");
      this.dateRangeParentTarget.classList.add("error");
      this.dateRangeErrorTarget.textContent = "Field is required";
    } else {
      if (validDateRanges.valid) {
        this.dateRangeNoticeTarget.classList.remove("d-none");
        this.dateRangeParentTarget.classList.remove("error");
        this.dateRangeErrorTarget.textContent = "";
      } else {
        this.dateRangeNoticeTarget.classList.add("d-none");
        this.dateRangeParentTarget.classList.add("error");
        this.dateRangeErrorTarget.textContent = validDateRanges.message;
      }
    }

    if ((locations.length + groups.length == 0) || reportName.length == 0 || dateRange.length == 0 || !validDateRanges.valid) {
      e.preventDefault()
    }
  }

  checkDateRanges(dateRange) {
    const ranges = dateRange.split(" - ");
    if (ranges.length != 2) {
      return { valid: false, message: "The date range is invalid format." };
    }
    const fromDate = new Date(ranges[0]);
    const toDate = new Date(ranges[1] || ranges[0]);
    const differenceInMs = toDate.getTime() - fromDate.getTime();
    const msPerDay = 1000 * 60 * 60 * 24; // 86400000 milliseconds in a day
    const daysDifference = Math.floor(differenceInMs / msPerDay);

    if (daysDifference > 7 * 5) { // 5 weeks
      return { valid: false, message: "The date range is longer than 5 weeks." };
    } else {
      return { valid: true }
    }
  }
}

